<div class="delivery">
  <hc-icon icon="note" [enable]="hasNote" [ngbTooltip]="'hc-order-icon.note' | transloco"></hc-icon>
  <hc-icon icon="decor" [enable]="hasDecor" [ngbTooltip]="'hc-order-icon.registration' | transloco"></hc-icon>
  <hc-icon icon="edit" [enable]="hasDecorText" [ngbTooltip]="'hc-order-icon.inscription' | transloco"></hc-icon>
  <hc-icon icon="delivery" [enable]="isDelivery" [ngbTooltip]="'hc-order-icon.delivery' | transloco"></hc-icon>
  <hc-icon icon="pickup" [enable]="!isDelivery" [ngbTooltip]="'hc-order-icon.pickup' | transloco"></hc-icon>
</div>
